import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Save, Loader2, Plus, Trash2 } from 'lucide-react';
import { client } from './AuthContext';

const empty = {
  hero_title: '',
  hero_subtitle: '',
  section_title: '',
  paragraphs: [''],
  tagline: '',
  vision: '',
  mission: '',
};

export default function AdminAbout() {
  const [form, setForm] = useState(empty);
  const [loaded, setLoaded] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    client
      .get('/api/site/about')
      .then((r) =>
        setForm({
          ...empty,
          ...r.data,
          paragraphs: r.data.paragraphs?.length ? r.data.paragraphs : [''],
        })
      )
      .finally(() => setLoaded(true));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const clean = {
        ...form,
        paragraphs: form.paragraphs.filter((p) => p.trim()),
      };
      await client.put('/api/admin/about', clean);
      toast.success('Halaman Tentang tersimpan');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Gagal menyimpan');
    } finally {
      setSaving(false);
    }
  };

  const setP = (i, v) => {
    const arr = [...form.paragraphs];
    arr[i] = v;
    setForm({ ...form, paragraphs: arr });
  };
  const addP = () => setForm({ ...form, paragraphs: [...form.paragraphs, ''] });
  const rmP = (i) =>
    setForm({
      ...form,
      paragraphs: form.paragraphs.filter((_, idx) => idx !== i),
    });

  return (
    <div data-testid="admin-about-page">
      <p className="text-xs tracking-[0.25em] text-px-red font-semibold mb-3">
        HALAMAN TENTANG
      </p>
      <h1 className="font-display text-4xl font-bold text-neutral-900 mb-2">
        Halaman Tentang
      </h1>
      <p className="text-neutral-600 mb-8">
        Kelola konten hero, cerita perusahaan, visi, dan misi.
      </p>

      <form
        onSubmit={save}
        className="bg-white rounded-2xl border border-neutral-200 p-8 space-y-6"
      >
        <Row label="Judul Hero">
          <input
            className={inputCls}
            value={form.hero_title}
            onChange={(e) => setForm({ ...form, hero_title: e.target.value })}
            data-testid="about-hero-title"
          />
        </Row>
        <Row label="Subtitle Hero">
          <textarea
            rows={3}
            className={`${inputCls} resize-none`}
            value={form.hero_subtitle}
            onChange={(e) =>
              setForm({ ...form, hero_subtitle: e.target.value })
            }
          />
        </Row>
        <Row label="Judul Section (Cerita Kami)">
          <input
            className={inputCls}
            value={form.section_title}
            onChange={(e) =>
              setForm({ ...form, section_title: e.target.value })
            }
          />
        </Row>

        <div>
          <div className="flex items-center justify-between mb-3">
            <label className="text-xs uppercase tracking-wider text-neutral-600 font-semibold">
              Paragraf Tentang
            </label>
            <button
              type="button"
              onClick={addP}
              className="text-xs font-semibold text-px-red inline-flex items-center gap-1"
            >
              <Plus className="w-3.5 h-3.5" /> Tambah paragraf
            </button>
          </div>
          <div className="space-y-3">
            {form.paragraphs.map((p, i) => (
              <div key={i} className="flex gap-2">
                <textarea
                  rows={3}
                  className={`${inputCls} resize-none flex-1`}
                  value={p}
                  onChange={(e) => setP(i, e.target.value)}
                />
                {form.paragraphs.length > 1 && (
                  <button
                    type="button"
                    onClick={() => rmP(i)}
                    className="text-neutral-400 hover:text-red-600 p-2"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        <Row label="Tagline Penutup">
          <input
            className={inputCls}
            value={form.tagline}
            onChange={(e) => setForm({ ...form, tagline: e.target.value })}
          />
        </Row>
        <Row label="Visi">
          <textarea
            rows={3}
            className={`${inputCls} resize-none`}
            value={form.vision}
            onChange={(e) => setForm({ ...form, vision: e.target.value })}
            data-testid="about-vision"
          />
        </Row>
        <Row label="Misi">
          <textarea
            rows={3}
            className={`${inputCls} resize-none`}
            value={form.mission}
            onChange={(e) => setForm({ ...form, mission: e.target.value })}
            data-testid="about-mission"
          />
        </Row>

        <button
          type="submit"
          disabled={saving || !loaded}
          data-testid="about-save-btn"
          className="inline-flex items-center gap-2 bg-px-red hover:bg-red-700 disabled:opacity-60 text-white font-semibold px-7 py-3 rounded-full transition-colors"
        >
          {saving ? (
            <>
              <Loader2 className="w-4 h-4 animate-spin" /> Menyimpan...
            </>
          ) : (
            <>
              <Save className="w-4 h-4" /> Simpan Perubahan
            </>
          )}
        </button>
      </form>
    </div>
  );
}

const inputCls =
  'mt-2 w-full bg-neutral-50 border border-neutral-200 focus:border-neutral-900 outline-none rounded-lg px-3 py-2.5 text-sm';

const Row = ({ label, children }) => (
  <div>
    <label className="text-xs uppercase tracking-wider text-neutral-600 font-semibold">
      {label}
    </label>
    {children}
  </div>
);
